import * as $runtime from "../runtime.js";
import * as Data$dArray from "../Data.Array/index.js";
import * as Data$dEither from "../Data.Either/index.js";
import * as Data$dMap$dInternal from "../Data.Map.Internal/index.js";
import * as Restaumatic$dForm$dDynamicResult from "../Restaumatic.Form.DynamicResult/index.js";
import * as Restaumatic$dForm$dErrors from "../Restaumatic.Form.Errors/index.js";
import * as Restaumatic$dForm$dResult from "../Restaumatic.Form.Result/index.js";
import * as Specular$dFRP$dBase from "../Specular.FRP.Base/index.js";
import * as Specular$dInternal$dIncremental from "../Specular.Internal.Incremental/index.js";
import * as Specular$dInternal$dIncremental$dNode from "../Specular.Internal.Incremental.Node/index.js";
const uniqFinal = dictMonadFRP => {
  const map1 = dictMonadFRP.MonadCleanup1().Monad0().Bind1().Apply0().Functor0().map;
  const uniqDynBy = Specular$dFRP$dBase.uniqDynBy(dictMonadFRP);
  return dictEq => {
    const $0 = map1(Restaumatic$dForm$dDynamicResult.wrap);
    const $1 = uniqDynBy(Restaumatic$dForm$dResult.eqResult(dictEq).eq);
    return x => $0($1(x));
  };
};
const unFinalV = x => Specular$dFRP$dBase.functorDynamic.map(Restaumatic$dForm$dResult.toVLax)(x);
const unFinal = x => Specular$dFRP$dBase.functorDynamic.map(Restaumatic$dForm$dResult.toMaybeLax)(x);
const makeFinalV = x => Specular$dFRP$dBase.functorDynamic.map(Restaumatic$dForm$dResult.liftV)(x);
const makeFinal = /* #__PURE__ */ (() => {
  const $0 = Specular$dFRP$dBase.functorDynamic.map(v2 => {
    if (v2.tag === "Nothing") { return Data$dEither.$Either("Left", Restaumatic$dForm$dErrors.unknownError); }
    if (v2.tag === "Just") { return Data$dEither.$Either("Right", v2._1); }
    $runtime.fail();
  });
  return x => Specular$dFRP$dBase.functorDynamic.map(Restaumatic$dForm$dResult.liftV)($0(x));
})();
const uniqPureFinal = dictEq => {
  const $0 = Specular$dFRP$dBase.uniqDynPureBy(x => y => {
    if (x.tag === "Nothing") { return y.tag === "Nothing"; }
    if (x.tag === "Just") {
      if (y.tag === "Just") { return dictEq.eq(x._1)(y._1); }
      return false;
    }
    return false;
  });
  return x => makeFinal($0(Specular$dFRP$dBase.functorDynamic.map(Restaumatic$dForm$dResult.toMaybeLax)(x)));
};
const liftMaybe = x => makeFinal((() => {
  const n = Specular$dInternal$dIncremental.constant(x);
  Specular$dInternal$dIncremental$dNode.annotate(n, "pure");
  return n;
})());
const liftDynamic = Restaumatic$dForm$dDynamicResult.liftDynamic;
const invalidFinal = /* #__PURE__ */ (() => {
  const $0 = Restaumatic$dForm$dResult.liftV(Data$dEither.$Either("Left", Restaumatic$dForm$dErrors.unknownError));
  return (() => {
    const n = Specular$dInternal$dIncremental.constant($0);
    Specular$dInternal$dIncremental$dNode.annotate(n, "pure");
    return n;
  })();
})();
const getErrors = /* #__PURE__ */ (() => {
  const $0 = Specular$dFRP$dBase.functorDynamic.map(v2 => {
    if (v2.tag === "Left") { return Data$dArray.concat(Data$dArray.fromFoldableImpl(Data$dMap$dInternal.foldableMap.foldr, v2._1)); }
    if (v2.tag === "Right") { return []; }
    $runtime.fail();
  });
  return x => $0(Specular$dFRP$dBase.functorDynamic.map(Restaumatic$dForm$dResult.toVLax)(x));
})();
const bindFinal = () => Restaumatic$dForm$dDynamicResult.andThen;
export {bindFinal, getErrors, invalidFinal, liftDynamic, liftMaybe, makeFinal, makeFinalV, unFinal, unFinalV, uniqFinal, uniqPureFinal};
